module.exports = __webpack_public_path__ + "img/Transpordiamet_vapp_varviline_ikoon.89518606.svg";